module.exports = __webpack_public_path__ + "img/banner2.8d2f4c08.png";